import { createValidator, minRange, required } from 'util/validation'

import { ConsultaSeguimentoAplicacaoModel, ConsultaSeguimentoFieldModel } from './model-consultaSeguimento'
import { validatorConsultaSeguimentoPergunta01 } from './perguntas/consulta-seguimento-pergunta-01/validator-consultaSeguimentoPergunta01'
import { validatorConsultaSeguimentoPergunta02 } from './perguntas/consulta-seguimento-pergunta-02/validator-consultaSeguimentoPergunta02'
import { validatorConsultaSeguimentoPergunta03 } from './perguntas/consulta-seguimento-pergunta-03/validator-consultaSeguimentoPergunta03'
import { validatorConsultaSeguimentoPergunta04 } from './perguntas/consulta-seguimento-pergunta-04/validator-consultaSeguimentoPergunta04'
import { validatorConsultaSeguimentoPergunta05 } from './perguntas/consulta-seguimento-pergunta-05/validator-consultaSeguimentoPergunta05'
import { validatorConsultaSeguimentoPergunta06 } from './perguntas/consulta-seguimento-pergunta-06/validator-consultaSeguimentoPergunta06'
import { validatorConsultaSeguimentoPergunta07 } from './perguntas/consulta-seguimento-pergunta-07/validator-consultaSeguimentoPergunta07'
import { validatorConsultaSeguimentoPergunta08 } from './perguntas/consulta-seguimento-pergunta-08/validator-consultaSeguimentoPergunta08'
import { validatorConsultaSeguimentoPergunta09 } from './perguntas/consulta-seguimento-pergunta-09/validator-consultaSeguimentoPergunta09'
import { validatorConsultaSeguimentoPergunta10 } from './perguntas/consulta-seguimento-pergunta-10/validator-consultaSeguimentoPergunta10'
import { validatorConsultaSeguimentoPergunta11 } from './perguntas/consulta-seguimento-pergunta-11/validator-consultaSeguimentoPergunta11'
import { validatorConsultaSeguimentoPergunta12 } from './perguntas/consulta-seguimento-pergunta-12/validator-consultaSeguimentoPergunta12'
import { validatorConsultaSeguimentoPergunta13 } from './perguntas/consulta-seguimento-pergunta-13/validator-consultaSeguimentoPergunta13'
import { validatorConsultaSeguimentoPergunta14 } from './perguntas/consulta-seguimento-pergunta-14/validator-consultaSeguimentoPergunta14'
import { validatorConsultaSeguimentoPergunta15 } from './perguntas/consulta-seguimento-pergunta-15/validator-consultaSeguimentoPergunta15'
import { validatorConsultaSeguimentoPergunta16 } from './perguntas/consulta-seguimento-pergunta-16/validator-consultaSeguimentoPergunta16'
import { validatorConsultaSeguimentoPergunta17 } from './perguntas/consulta-seguimento-pergunta-17/validator-consultaSeguimentoPergunta17'
import { validatorConsultaSeguimentoPergunta18 } from './perguntas/consulta-seguimento-pergunta-18/validator-consultaSeguimentoPergunta18'
import { validatorConsultaSeguimentoPergunta19 } from './perguntas/consulta-seguimento-pergunta-19/validator-consultaSeguimentoPergunta19'
import { validatorConsultaSeguimentoPergunta20 } from './perguntas/consulta-seguimento-pergunta-20/validator-consultaSeguimentoPergunta20'

export const validatorConsultaSeguimento = createValidator<ConsultaSeguimentoFieldModel>({
  perguntasSelecionadas: (perguntasSelecionadas) => [
    required(perguntasSelecionadas),
    minRange(3)(perguntasSelecionadas.length),
  ],
  aplicacao: createValidator<ConsultaSeguimentoAplicacaoModel>({
    PERGUNTA_01: validatorConsultaSeguimentoPergunta01,
    PERGUNTA_02: validatorConsultaSeguimentoPergunta02,
    PERGUNTA_03: validatorConsultaSeguimentoPergunta03,
    PERGUNTA_04: validatorConsultaSeguimentoPergunta04,
    PERGUNTA_05: validatorConsultaSeguimentoPergunta05,
    PERGUNTA_06: validatorConsultaSeguimentoPergunta06,
    PERGUNTA_07: validatorConsultaSeguimentoPergunta07,
    PERGUNTA_08: validatorConsultaSeguimentoPergunta08,
    PERGUNTA_09: validatorConsultaSeguimentoPergunta09,
    PERGUNTA_10: validatorConsultaSeguimentoPergunta10,
    PERGUNTA_11: validatorConsultaSeguimentoPergunta11,
    PERGUNTA_12: validatorConsultaSeguimentoPergunta12,
    PERGUNTA_13: validatorConsultaSeguimentoPergunta13,
    PERGUNTA_14: validatorConsultaSeguimentoPergunta14,
    PERGUNTA_15: validatorConsultaSeguimentoPergunta15,
    PERGUNTA_16: validatorConsultaSeguimentoPergunta16,
    PERGUNTA_17: validatorConsultaSeguimentoPergunta17,
    PERGUNTA_18: validatorConsultaSeguimentoPergunta18,
    PERGUNTA_19: validatorConsultaSeguimentoPergunta19,
    PERGUNTA_20: validatorConsultaSeguimentoPergunta20,
  }),
})

export const CONSULTA_SEGUIMENTO_NAO_PARA_TODOS_VALIDATION_MESSAGE =
  'Pelas orientações do instrumento, não é possível marcar “Não” em todas as perguntas.'
